export { default as bigBrainEvents } from './bigbrain-events';
export { default as noticeTypes } from './notice-types';
export { default as adjustments } from './adjustments';

export const NO_OP = () => {};
export const S3_BUCKET_PREFIX = process.env.REACT_APP_S3_BUCKET_PREFIX;
export const ARTICLE_LINK = 'https://support.monday.com/hc/en-us/articles/360019033299-Create-quotes-on-monday-com';
